import React, {Component} from 'react';

class Youtube extends Component{
    render(){
        return(
            <div>
                <div className="youtube">
                    <iframe src="https://www.youtube.com/embed/EypTSjHoFsg?ecver=2" width="640" height="360" frameBorder="0" allowFullScreen></iframe>
                </div>
                <div className="youtube">
                    <iframe src="https://www.youtube.com/embed/1CmqM9gAwGI?ecver=2" width="640" height="360" frameBorder="0" allowFullScreen></iframe>
                </div>
                <div className="youtube">
                    <iframe src="https://www.youtube.com/embed/QbGdv0yb5r4?ecver=2" width="640" height="360" frameBorder="0" allowFullScreen></iframe>
                </div>
                <div className="youtube">
                    <iframe src="https://www.youtube.com/embed/ajnqsZeZZAw?ecver=2" width="640" height="360" frameBorder="0" allowFullScreen></iframe>
                </div>
                <div className="youtube">
                    <iframe src="https://www.youtube.com/embed/FspUmC2lhOA?ecver=2" width="640" height="360" frameBorder="0" allowFullScreen></iframe>
                </div>
            </div>

        );
    }
}

export default Youtube;


// WEBPACK FOOTER //
// ./src/Youtube.js